import {
	SETTINGS_PAGE_BACK_TO_BEGINNING,
	CHANGE_PREFERRED_GAMES_NAVIGATE,
	CHANGE_PLAYER_SETTING_BEGIN,
	CHANGE_PLAYER_SETTING_FAIL,
	CHANGE_PROFILE_SETTING_BEGIN,
	CHANGE_PROFILE_SETTING_FAIL,
	CHEAT_CODE_ACTIVATED,
	TOGGLE_SHOW_MAIN_CHAT_AS_POPUP, TOGGLE_FORCE_CHAT_PLUS_MATCH_VIEW, TOGGLE_SHOW_STREAM_VIEW_ALWAYS,
} from '../actions/settings';
import { Dashboard } from '../../../components/Dashboard';
import { ladderLocalStorage } from '../../../components/Ladder';
import { friendStates } from '../actions/chat';


const initialState = {
	selectingPreferredGames: null,
	playerSettings: {},
	playerProfileSettings: {},
	cheatCodeActivated: ladderLocalStorage.getItem('cheatCodeActivated', false),
	openPrivateChats: {},
	forceChatPlusMatchViewForSmallScreens: ladderLocalStorage.getItem('forceChatPlusMatchViewForSmallScreens', false),
	showMainChatAsPopup: false && ladderLocalStorage.getItem('showMainChatAsPopup', true),
	showStreamViewTabEvenWhenNotStreaming: ladderLocalStorage.getItem('showStreamViewTabEvenWhenNotStreaming', false),

};

export default (state = initialState, action) => {
	switch(action.type) {
		case CHANGE_PROFILE_SETTING_BEGIN:
		case CHANGE_PROFILE_SETTING_FAIL: {
			// BEGIN applies the new value; FAIL puts the previous one back (no
			// payload when a later save superseded the failed one).
			if(!action.payload) {
				return state;
			}
			const { name } = action.payload;
			const value = action.type === CHANGE_PROFILE_SETTING_FAIL ? action.payload.previousValue : action.payload.value;
			myUser.settings.update({ [name]: value });
			return {
				...state,
				playerProfileSettings: { ...state.playerProfileSettings, [name]: value }
			};
		}
		case CHANGE_PLAYER_SETTING_BEGIN:
		case CHANGE_PLAYER_SETTING_FAIL: {
			if(!action.payload) {
				return state;
			}
			const { name } = action.payload;
			const value = action.type === CHANGE_PLAYER_SETTING_FAIL ? action.payload.previousValue : action.payload.value;
			myUser.update({ [name]: value });
			return {
				...state,
				playerSettings: { ...state.playerSettings, [name]: value }
			};
		}
		case SETTINGS_PAGE_BACK_TO_BEGINNING:
			return {
				...state,
				selectingPreferredGames: null,
			};
		case CHANGE_PREFERRED_GAMES_NAVIGATE:
			return {
				...state,
				selectingPreferredGames: action.payload,
			};
		case CHEAT_CODE_ACTIVATED: {
			const setTo = action.payload;
			ladderLocalStorage.setItem('cheatCodeActivated', setTo);

			return {
				...state,
				cheatCodeActivated: setTo
			};
		}
		case TOGGLE_SHOW_MAIN_CHAT_AS_POPUP: {
			const setTo = true || !state.showMainChatAsPopup;
			ladderLocalStorage.setItem('showMainChatAsPopup', setTo);
			return {
				...state,
				showMainChatAsPopup: setTo,
			};
		}
		case TOGGLE_SHOW_STREAM_VIEW_ALWAYS: {
			const setTo = !state.showStreamViewTabEvenWhenNotStreaming;
			ladderLocalStorage.setItem('showStreamViewTabEvenWhenNotStreaming', setTo);
			return {
				...state,
				showStreamViewTabEvenWhenNotStreaming: setTo,
			};
		}
		case TOGGLE_FORCE_CHAT_PLUS_MATCH_VIEW: {
			const setTo = !state.forceChatPlusMatchViewForSmallScreens;
			ladderLocalStorage.setItem('forceChatPlusMatchViewForSmallScreens', setTo);

			return {
				...state,
				forceChatPlusMatchViewForSmallScreens: setTo
			};
		}
		default:
			return state;
	}
}